import { onBeforeUnmount, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { useConfirm } from 'src/composables/app/useConfirm'

import { COMPANY_EDIT_STEPS } from 'src/services/consts/company.const'
import { ROUTES } from 'src/services/consts/routes.const'

const submitFnMap = ref({})
const resyncFnMap = ref({})
const isDirtyMap = ref({})
const currentStep = ref(COMPANY_EDIT_STEPS.INFO)
const isUpdating = ref(false)

/** After notification refresh on company edit — resync active step and clear dirty. */
export function applyCompanyEditRefresh() {
  const step = currentStep.value
  if (resyncFnMap.value[step]) {
    resyncFnMap.value[step]()
  }
  isDirtyMap.value[step] = false
}

export function useCompanyForm() {
  const router = useRouter()
  const route = useRoute()
  const { confirmLeave } = useConfirm()

  onMounted(() => {
    const { step } = route.params
    if (step) {
      currentStep.value = step
    }
  })

  onBeforeUnmount(() => {
    isDirtyMap.value[currentStep.value] = false
  })

  const register = (step, fn) => {
    currentStep.value = step
    submitFnMap.value[currentStep.value] = fn
  }

  const registerResync = (step, fn) => {
    resyncFnMap.value[step] = fn
  }

  const submit = () => {
    if (submitFnMap.value[currentStep.value]) {
      submitFnMap.value[currentStep.value]()
    }
  }

  const setIsDirty = (isDirty) => {
    isDirtyMap.value[currentStep.value] = isDirty
  }

  const onUpdateStep = (step) => {
    if (!step) return
    if (isDirtyMap.value[currentStep.value]) {
      confirmLeave(() => {
        isDirtyMap.value[currentStep.value] = false
        currentStep.value = step
        router.replace({ name: ROUTES.COMPANY_EDIT, params: { ...route.params, step } })
      })
    } else {
      currentStep.value = step
      router.replace({ name: ROUTES.COMPANY_EDIT, params: { ...route.params, step } })
    }
  }

  const setIsUpdating = (val) => {
    isUpdating.value = val
  }

  return {
    currentStep,
    isDirtyMap,
    isUpdating,
    register,
    registerResync,
    submit,
    setIsDirty,
    onUpdateStep,
    setIsUpdating,
  }
}
